import { ReactNode } from "react";
import ClaroRaysIcon from "@/assets/Img/ClaroPay/claro-rays.svg?react";
import classNames from "classnames";

interface ClaroTextProps {
  text: string;
  extra?: ReactNode;
  className?: string;
  textClassName?: string;
}

export const ClaroText = ({
  text,
  extra,
  className,
  textClassName,
}: ClaroTextProps) => {
  return (
    <div className={classNames("flex items-start gap-2 mt-4", className)}>
      <ClaroRaysIcon className="w-8 h-8 -translate-y-4 -mr-4 text-red-600 flex-shrink-0" />
      <p
        className={classNames("text-xl lg:text-2xl font-medium", textClassName)}
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {extra ? extra : null}
    </div>
  );
};
